import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import L, { point } from "leaflet";
import { useLanguage } from "../../../Language/LanguageContext";

import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import AuthService_Operation from "../../../services/Operation.serviceV3";
import {
  MapContainer,
  TileLayer,
  Polygon,
} from "react-leaflet";
import UserOperationContentModal from "../../user/drone/UserOperationContentModal";
import Static_modal from "../../user/etc/Static_modal";
import { Button, Tooltip, Overlay, Spinner, Table, Modal } from "react-bootstrap";
import * as turf from "@turf/turf";
////React-Icon
import { RiFileExcel2Line } from "react-icons/ri";
import { TbDrone } from "react-icons/tb";
import { MdSettingsRemote } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { LuCopyPlus, LuCopyCheck, LuCopyMinus } from "react-icons/lu";
//Steps
import Plan_Status from "../../../Style_Component/Steps/Plan_Status";
//Prime
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";

//Icons
import { MdDateRange } from "react-icons/md";
import { FaUserAstronaut } from "react-icons/fa";
import { GiDeliveryDrone } from "react-icons/gi";
import docgif from "../../../picture/investigation.gif";


export default function SpecialOperation(prop) {
  const mapRef = useRef(null);
  const Navigate = useNavigate();
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [itemsB, setItemsB] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showApproveDroneList, setShowAprroveDroneList] = useState(false);
  const [target, setTarget] = useState(null);
  const [showUserOperationModal, setShowUserOperationModal] = useState(false);
  const handleToggleUserOperationModal = () => {
    setShowUserOperationModal(!showUserOperationModal);
  };
  const [selectedInformation, setSelectedInformation] = useState([]);
  //modal config
  const [textBody, setTextBody] = useState();
  const [modalToggle, setModalToggle] = useState({
    showdata_check: false,
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });

  const handleClick = (event) => {
    setShowTooltip(!showTooltip);
    setTarget(event.target);


  };
  const handleClose_Modal = () => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: false,
      modalDenied: false,
      modalErr: false,
      modalwait: false,
    });
    setTextBody("");
  };

  const [member_joining, setMember_Joining] = useState([]);
  function Get_Operation_Drone(operation_id) {
    console.log(operation_id);
    try {
      AuthServiceV2.Opearationdata(operation_id)
        .then((res) => {
          console.log(res);
          if (res !== undefined) {
            if (res.status === 200) {
              console.log(res.data.agency_data[0].drone_pilot_data);
              setMember_Joining(res.data.agency_data[0].drone_pilot_data);
              setTimeout(() => {
                handleClose_Modal();
                setShowAprroveDroneList(true);
              }, 1000);
              console.log(member_joining);
            } else {
              alert(res.data.error_description);
            }
          } else {
            alert("ไม่พบข้อมูล");
          }
        })
        .catch((err) => {
          alert("เกิดข้อผิดพลาด");
        });
    } catch (err) {
      alert("เกิดข้อผิดพลาด");
    }
  }
  //prime table config
  const [globalFilter, setGlobalFilter] = useState("");
  function filtered_itemB(data) {
    console.log(data);
    const filteredData = data.filter(
      (item) =>
        item.id
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.start_time
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.operation_status_name
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.end_time
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join(""))
    );

    return filteredData;
  }


    const [valuetool, setValuetool] = useState();
    const [clipboard_icon, setclipboard_Icon] = useState(
      <LuCopyPlus style={{ width: "25px", height: "25px" }} />
    );
 
    const ClipBoard = (text) => {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    };
    const ClipBHover = () => {
      setclipboard_Icon(
        <LuCopyMinus style={{ width: "25px", height: "25px" }} />
      );
    };
  
    const ClipBClick = (text) => {
      setclipboard_Icon(
        <LuCopyCheck style={{ width: "25px", height: "25px", color: "green" }} />
      );
      ClipBoard(text);
    };

  const Body_number = (data) => {
    return (
      <>
        <Button
          onClick={(e) => handleClick(e)}
          value={data.id}
          style={{
            background: "none",
            border: "none",
            color: "#575757",
            fontSize: "20px",
          }}
        >
          {data.id}
        </Button>
        <Overlay
          show={showTooltip}
          target={target}
          placement="top"
        container={document.body}
        containerPadding={20}
        >
          <Tooltip id="tooltip">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>คัดลอกรหัสปฏิบัติการเรียบร้อย</p>
            </div>
            <div>{valuetool}</div>
          <div
            style={{ marginTop: "5px" }}
            onMouseEnter={ClipBHover}
            onClick={() => ClipBClick(data.id)}
          >
            {clipboard_icon}
          </div>
          </Tooltip>
        </Overlay>
      </>
    );
  };
  const Body_Operation_Type = (data) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p>{data.operation_type.split("-")[0]}</p>
        </div>
      </>
    );
  };
  const Body_Status = (data) => {
    return (
      <Plan_Status status={data.operation_status_name ?? "ติดต่อเจ้าหน้าที่"} />
    );
  };

  const Body_pilot_join = (data) => {
    return (
      <>
        <TbDrone
          style={{ cursor: "pointer", fontSize: "25px" }}
          className="investigate-button"
          onClick={() => {
            setModalToggle({
              ...modalToggle,
              modalwait: true,
            });
            Get_Operation_Drone(data.operation_id);
          }}
        />
        {data.operation_count >= 0 ? (
          <sup style={{ color: "green", fontWeight: "500" }}>
            {data.operation_count}
          </sup>
        ) : null}
      </>
    );
  };
  const Body_Information = (data) => {
    return (
      <div>
        <p
          style={{ cursor: "pointer", fontSize: "25px", margin: "0px" }}
          className="investigate-button"
          onClick={() => {
            setShowUserOperationModal(true);
            setSelectedInformation([
              data.id,
              data.operation_type,
              data.start_time,
              data.end_time,
              data.operation_area.Volume3D.outline_polygon.vertices,
              data.operation_area.Volume3D.altitude,
              data.pilot_name,
              data.drone_model,
              data.purpose,
            ]);
          }}
        >
          <img
            alt="checkdata"
            src={docgif}
            style={{ width: "40px", height: "40px" }}
          />
        </p>

      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <div> </div>
        {/* <h4 className="m-0">สถานะการลงทะเบียนโดรน</h4> */}
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const header = renderHeader();
  const RenderLoading = () => {
    return (
      <>
        <h2 className="profile-header">ปฏิบัติการพิเศษ</h2>
        <div className="user-main">
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {" "}
            <Spinner animation="border" variant="secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      </>
    )
  }

  const getOperation = async() => {
    let operationlist = AuthServiceV2.Opearationdata();
    if (operationlist != null) {
      operationlist
        .then((response) => {
          console.log(response.data);
          const tempArray2 = [];
          for (
            let operationCount = 0;
            operationCount < response.data.agency_data.length;
            operationCount++
          ) {
            tempArray2.push(response.data.agency_data[operationCount]);
          }  
          setItemsB(tempArray2.reverse());
          setTimeout(() => {
            setLoading(false);
          }, 500);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  useEffect(() => {
    const fetch = async () => {
      await getOperation();
    }
    fetch();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  return (
    <>
      {loading ? <RenderLoading /> :
        <>
          <h2 className="profile-header">ปฏิบัติการพิเศษ</h2>
          <DataTable
            value={globalFilter ? filtered_itemB(itemsB) : itemsB}
            paginator
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rows={5}
            rowsPerPageOptions={[5, 10]}
            header={header}
            emptyMessage="ไม่มีข้อมูล"
            tableStyle={{ minWidth: "50rem" }}
            style={{ fontFamily: "Kanit" }}
          >
            <Column
              header={t('operationlist.OperationCode')}
              body={Body_number}
              field={`id`}
              sortable
              filterField="id"
              dataType="date"
              bodyStyle={{ alignItems: "center", textAlign: "center" }}
              style={{ width: "12%" }}
            ></Column>
            <Column
              header={t('operationlist.type')}
              body={Body_Operation_Type}
              field="operation_type"
              sortable
              filterField="operation_type"
              //sortFunction={customSort}
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.status')}
              body={Body_Status}
              field={`operation_status_name`}
              sortable
              filterField="operation_status_name"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "15%" }}
            ></Column>
            <Column
              header={t('operationlist.pilotjoin')}
              field={"operation_area.aircraft_count"}
              body={Body_pilot_join}
              sortable
              filterField="operation_area.aircraft_count"
              //sortFunction={customSort}
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "12%" }}
            ></Column>
            <Column
              header={t('operationlist.checkdata')}
              body={Body_Information}
              field={`built_in_rid`}
              //sortable
              filterField="built_in_rid"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "20%" }}
            ></Column>
          </DataTable>

        </>}



    </>
  );
};

